<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.processes'">
    <div class="form-group row">
      <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="code" name="code" [(ngModel)]="process.Code">
      </div>
    </div>
    <div class="form-group row">
      <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="process.Name">
      </div>
    </div>
    <div class="form-group row">
      <label for="number" class="col-sm-4 col-form-label">{{t('Number')}}</label>
      <div class="col-sm-8">
        <input type="number" class="form-control" name="number" id="number" [(ngModel)]="process.Number">
      </div>
    </div>
    <div class="form-group row">
      <label for="Comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="Comment" id="Comment" [(ngModel)]="process.Comment"></textarea>
      </div>
    </div>
    <div class="form-group row">
      <label for="from" class="col-sm-4 col-form-label">{{t('From')}}</label>
      <div class="col-sm-8">
        <mes-web-process-select [items$]="processesQuery.getAll$" name="from" id="from" [entityIds]="process.From" [multiple]="true" (entityIdsChange)="process.From = $event"></mes-web-process-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="to" class="col-sm-4 col-form-label">{{t('To')}}</label>
      <div class="col-sm-8">
        <mes-web-process-select [items$]="processesQuery.getAll$" name="to" id="to" [entityIds]="process.To" [multiple]="true" (entityIdsChange)="process.To = $event"></mes-web-process-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="card-title d-flex pb-1">
              <h5 class="d-inline-block">{{t('Specs')}}</h5>
              <div class="ms-auto">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent.addNewSpecLine()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                  {{t('Add')}}
                </button>
              </div>
            </div>
            <ime-spec-lines-edit [context]="process" [wasValidated$]="wasValidated$" (changed)="setChanged()"/>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>

